"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultCreateGameModel = defaultCreateGameModel;
const constants = __importStar(require("@/common/constants"));
const BoardName_1 = require("@/common/boards/BoardName");
const GameModule_1 = require("@/common/cards/GameModule");
const RandomMAOptionType_1 = require("@/common/ma/RandomMAOptionType");
function defaultCreateGameModel() {
    return {
        firstIndex: 1,
        playersCount: 1,
        players: [
            { name: '', color: 'red', beginner: false, handicap: 0, first: false },
            { name: '', color: 'green', beginner: false, handicap: 0, first: false },
            { name: '', color: 'yellow', beginner: false, handicap: 0, first: false },
            { name: '', color: 'blue', beginner: false, handicap: 0, first: false },
            { name: '', color: 'black', beginner: false, handicap: 0, first: false },
            { name: '', color: 'purple', beginner: false, handicap: 0, first: false },
            { name: '', color: 'orange', beginner: false, handicap: 0, first: false },
            { name: '', color: 'pink', beginner: false, handicap: 0, first: false },
        ],
        expansions: { ...GameModule_1.DEFAULT_EXPANSIONS },
        draftVariant: true,
        initialDraft: false,
        randomMA: RandomMAOptionType_1.RandomMAOptionType.NONE,
        modularMA: false,
        randomFirstPlayer: true,
        showOtherPlayersVP: false,
        showCeosList: false,
        showColoniesList: false,
        showCorporationList: false,
        showPreludesList: false,
        showBannedCards: false,
        showIncludedCards: false,
        customCeos: [],
        customColonies: [],
        customCorporations: [],
        customPreludes: [],
        bannedCards: [],
        includedCards: [],
        board: BoardName_1.BoardName.THARSIS,
        seed: Math.random(),
        seededGame: false,
        solarPhaseOption: false,
        shuffleMapOption: false,
        aresExtremeVariant: false,
        politicalAgendasExtension: 'Standard',
        undoOption: false,
        showTimers: true,
        fastModeOption: false,
        removeNegativeGlobalEventsOption: false,
        includeFanMA: false,
        startingCorporations: 2,
        soloTR: false,
        clonedGameId: undefined,
        allOfficialExpansions: false,
        requiresVenusTrackCompletion: false,
        requiresMoonTrackCompletion: false,
        moonStandardProjectVariant: false,
        moonStandardProjectVariant1: false,
        altVenusBoard: false,
        escapeVelocityMode: false,
        escapeVelocityThreshold: constants.DEFAULT_ESCAPE_VELOCITY_THRESHOLD,
        escapeVelocityBonusSeconds: constants.DEFAULT_ESCAPE_VELOCITY_BONUS_SECONDS,
        escapeVelocityPeriod: constants.DEFAULT_ESCAPE_VELOCITY_PERIOD,
        escapeVelocityPenalty: constants.DEFAULT_ESCAPE_VELOCITY_PENALTY,
        twoCorpsVariant: false,
        startingCeos: 3,
        startingPreludes: 4,
        preludeDraftVariant: undefined,
        ceosDraftVariant: undefined,
    };
}
